import { createElement as _createElement } from "react";
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { OrderStatus } from '@application/common/enums/order-status';
import { useAppSelector } from '@application/store/useStore';
import { formatDMY } from '@infrastructure/helpers';
import { IonIcon } from '@ionic/react';
import VnButton from '@ui/components/VnButton';
import { gridHeaderDropdownStyle } from '@ui/styles/grid-header-dropdown-style';
import { arrowDown, arrowUp, funnelOutline, close, calendarOutline } from 'ionicons/icons';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useState } from 'react';
import Select from 'react-select';
import { useTable } from 'react-table';
import DatePicker from 'react-datepicker';
import '../../../styles/custom-table-style.css';
const OrderTable = ({ orders, onRowClick, onSorting, onFilter, defaultSortingCriteria }) => {
    const [sortingCriteria, setSortingCriteria] = useState(null);
    const [showFilters, setShowFilters] = useState(false);
    const [filterValues, setFilterValues] = useState({});
    const { OrderStatusDropdown } = useAppSelector((state) => state.order);
    const columns = React.useMemo(() => [
        { Header: 'Bestelnummer', accessor: 'orderNumber' },
        { Header: 'Datum aangemaakt', accessor: 'created', Cell: ({ value }) => _jsx(_Fragment, { children: value ? formatDMY(value.toString()) : '' }) },
        { Header: 'Leverancier', accessor: 'supplierName' },
        // { Header: 'Werkorder', accessor: 'workorderNumber' },
        // { Header: 'Klant', accessor: 'debtorName' },
        // { Header: 'Omschrijving werkorder', accessor: 'workorderDescription' },
        { Header: 'Besteldatum', accessor: 'orderDate', Cell: ({ value }) => _jsx(_Fragment, { children: value ? formatDMY(value.toString()) : '' }) },
        { Header: 'Leverdatum', accessor: 'deliveryDate', Cell: ({ value }) => _jsx(_Fragment, { children: value ? formatDMY(value.toString()) : '' }) },
        { Header: 'Status', accessor: 'statusName' },
        {
            Header: 'Dagen te laat',
            accessor: 'daysLate',
            Cell: ({ row }) => _jsx(_Fragment, { children: calculateTooLate(row.original.deliveryDate, row.original.statusId) })
        },
        { Header: 'Aangemaakt door', accessor: 'createdBy' }
    ], []);
    const data = React.useMemo(() => orders || [], [orders]);
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data });
    useEffect(() => {
        const newSortingCriteria = {
            sortColumnKey: defaultSortingCriteria.sortColumnKey,
            sortDirection: defaultSortingCriteria.sortDirection
        };
        setSortingCriteria(newSortingCriteria);
    }, []);
    const handleSort = (column) => {
        if (column.id == 'daysLate') {
            const sortColumnKey = 'daysLate';
            const sortDirection = sortingCriteria?.sortDirection === 'asc' ? 'desc' : 'asc';
            const newSortingCriteria = { sortColumnKey, sortDirection };
            onSorting({
                sortColumnKey: 'deliveryDate',
                sortDirection: sortDirection
            });
            setSortingCriteria(newSortingCriteria);
        }
        else {
            setSortingCriteria((prevSortingCriteria) => {
                const currentSortDirection = prevSortingCriteria?.sortDirection || 'asc';
                const sortDirection = column.id === prevSortingCriteria?.sortColumnKey ? (currentSortDirection === 'asc' ? 'desc' : 'asc') : 'asc';
                const newSortingCriteria = {
                    sortColumnKey: column.id,
                    sortDirection: sortDirection
                };
                onSorting(newSortingCriteria);
                return newSortingCriteria;
            });
        }
    };
    const handleFilterChange = (columnId, value) => {
        setFilterValues((prevFilterValues) => {
            var updatedFilterValues = {
                ...prevFilterValues,
                [columnId]: value
            };
            if (typeof value === 'string' && value.length >= 2) {
                applyFilter(updatedFilterValues);
            }
            else if (value instanceof Date) {
                applyFilter(updatedFilterValues);
            }
            else if (typeof value != 'string' && typeof value != typeof Date) {
                applyFilter(updatedFilterValues);
            }
            if (typeof value === 'string' && value.length == 0) {
                const resetFilterValue = {
                    ...prevFilterValues,
                    [columnId]: null
                };
                updatedFilterValues = resetFilterValue;
                applyFilter(resetFilterValue);
            }
            return updatedFilterValues;
        });
    };
    const applyFilter = (filterValues) => {
        onFilter(filterValues);
    };
    const clearFilters = () => {
        const nullFilterValues = Object.fromEntries(Object.keys(filterValues).map((key) => [key, null]));
        setFilterValues({});
        setShowFilters(!showFilters);
        onFilter(nullFilterValues);
    };
    const [datePickerIsOpen, setDatePickerIsOpen] = useState({
        orderDate: false,
        deliveryDate: false,
        created: false
    });
    const toggleDatePicker = (columnId) => {
        setDatePickerIsOpen((prevDatePickerIsOpen) => ({
            ...Object.fromEntries(Object.keys(prevDatePickerIsOpen).map((key) => [key, key === columnId ? !prevDatePickerIsOpen[key] : false]))
        }));
    };
    function calculateTooLate(deliveryDate, status) {
        if (status == OrderStatus.In_bestelling) {
            const currentDate = new Date();
            const timeDifference = new Date(deliveryDate).getTime() - currentDate.getTime();
            const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
            return daysDifference < 0 ? Math.abs(daysDifference) : 0;
        }
        else
            return 0;
    }
    const handleRowClick = (row) => {
        onRowClick(row.original.id);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'd-flex justify-content-end mb-2 vn-filter-button-container', children: _jsx("div", { className: 'filter-header-container', children: _jsx(VnButton, { style: { borderRadius: '8px', minWidth: '41px', height: '37px', width: '20px' }, customClassName: !showFilters ? 'vn-header-buttons' : 'vn-header-buttons vn-table-filter-remove-button', icon: funnelOutline, customIconClassName: 'vn-action-button-icon', mode: 'danger', onClick: () => {
                            !showFilters ? setShowFilters(!showFilters) : clearFilters();
                        } }) }) }), _jsx("div", { className: 'custom-table-container', children: _jsx("div", { className: 'vn-table-container', children: _jsx("div", { className: 'vn-main', children: _jsxs("table", { ...getTableProps(), className: 'table', children: [_jsx("thead", { className: 'vn-table-thead', children: headerGroups.map((headerGroup) => (_jsxs(React.Fragment, { children: [_jsx("tr", { ...headerGroup.getHeaderGroupProps(), className: 'vn-custom-grid-header-card', children: headerGroup.headers.map((column) => (_jsx("th", { ...column.getHeaderProps(), style: { cursor: 'pointer', padding: '16px' }, children: _jsxs("div", { onClick: () => handleSort(column), className: 'vn-grid-header-sort-inline customTable-header-caption', children: [column.render('Header'), sortingCriteria && sortingCriteria.sortColumnKey === column.id && (_jsx("span", { children: sortingCriteria.sortDirection === 'asc' ? (_jsx(IonIcon, { icon: arrowUp, className: 'ml-1 vn-grid-sorting-icon' })) : (_jsx(IonIcon, { icon: arrowDown, className: 'ml-1 vn-grid-sorting-icon' })) }))] }) }))) }), showFilters && (_jsx("tr", { children: headerGroup.headers.map((column) => (_jsx("td", { style: { borderBottomColor: '#80808047' }, children: column.id === 'orderDate' ||
                                                        column.id === 'deliveryDate' ||
                                                        column.id === 'created' ? (_jsxs("div", { className: 'input-group', style: { width: '160px' }, children: [_jsx(DatePicker, { portalId: 'root', className: 'form-control vn-Input', open: datePickerIsOpen[column.id], onClickOutside: () => toggleDatePicker(column.id), onChange: (date) => {
                                                                    handleFilterChange(column.id, moment(date).format('YYYY-MM-DD'));
                                                                    toggleDatePicker(column.id);
                                                                }, dateFormat: 'dd/MM/yyyy', timeCaption: 'DateTime', showMonthDropdown: true, showYearDropdown: true, dropdownMode: 'select', value: filterValues[column.id]
                                                                    ? formatDMY(filterValues[column.id].toString())
                                                                    : formatDMY(filterValues[column.id]?.toString()), onCalendarClose: () => toggleDatePicker(column.id), readOnly: true, onKeyDown: (e) => {
                                                                    if (e.key === 'Backspace') {
                                                                        handleFilterChange(column.id, null);
                                                                    }
                                                                } }), filterValues[column.id] && (_jsx("div", { className: 'input-group-append', children: _jsx(IonIcon, { icon: close, className: 'vn-Datepicker-Icon datepicker-cancel-icon', onClick: () => handleFilterChange(column.id, null) }) })), _jsx("div", { className: 'input-group-append', children: _jsx(IonIcon, { icon: calendarOutline, className: 'vn-Datepicker-Icon', onClick: () => toggleDatePicker(column.id) }) })] })) : column.id === 'statusName' ? (_jsx("div", { style: { minHeight: '37px', marginLeft: '-6px' }, children: _jsx(Select, { menuPosition: 'fixed', isSearchable: false, styles: gridHeaderDropdownStyle, placeholder: 'Selecteer Status', value: OrderStatusDropdown?.find((option) => option.value === filterValues[column.id]), options: OrderStatusDropdown, onChange: (selectedOption) => {
                                                                handleFilterChange('statusName', selectedOption ? selectedOption.value : undefined);
                                                            }, isClearable: true }) })) : column.id != 'daysLate' ? (_jsx("div", { style: { width: '140px' }, children: _jsx("input", { className: 'form-control vn-Input', type: 'text', value: filterValues[column.id] || '', onChange: (e) => handleFilterChange(column.id, e.target.value) }) })) : (_jsx("div", { style: { width: '140px' } })) }, column.id ? column.id : 0))) }))] }, headerGroup.id ? headerGroup.id : 0))) }), rows && data && (_jsx("tbody", { ...getTableBodyProps(), className: 'vn-table-tbody', children: rows.map((row) => {
                                        prepareRow(row);
                                        return (_jsx("tr", { ...row.getRowProps(), style: { cursor: 'pointer' }, onClick: () => handleRowClick(row), children: row.cells.map((cell, index) => (_createElement("td", { ...cell.getCellProps(), key: index ? index : 0, style: { padding: '4px' } },
                                                _jsx("span", { children: cell.render('Cell') })))) }));
                                    }) }))] }) }) }) })] }));
};
export default OrderTable;
